export default __webpack_public_path__ + "static/23_18-8595ddf4e5286632fa5067171fd654ec.png";